import { html } from "htm/preact";
import { type FunctionComponent } from "preact";

import { ThemeProvider } from "./ThemeProvider";

export const Providers: FunctionComponent = ({ children }) => {
  return html`<${ThemeProvider}>${children}<//>`;
};
